import React, { useEffect, useRef, useState } from 'react';
import './Intro.css';

const MOBILE_BREAKPOINT = 768;

const Intro = ({ onComplete }) => {
  const videoRef = useRef(null);
  const [videoSrc, setVideoSrc] = useState(null);
  const [hasStarted, setHasStarted] = useState(false);
  const [isStarting, setIsStarting] = useState(false);

  useEffect(() => {
    const updateVideoSource = () => {
      if (hasStarted) {
        return;
      }

      if (window.innerWidth <= MOBILE_BREAKPOINT) {
        setVideoSrc('/EddieTV_Vertical_Ident.mp4');
        return;
      }

      setVideoSrc('/Eddie_Intro.mp4');
    };

    updateVideoSource();
    window.addEventListener('resize', updateVideoSource);

    return () => window.removeEventListener('resize', updateVideoSource);
  }, [hasStarted]);

  useEffect(() => {
    const video = videoRef.current;

    if (!video || !videoSrc) {
      return;
    }

    video.load();
  }, [videoSrc]);

  const handleStart = async () => {
    const video = videoRef.current;

    if (!video || !videoSrc || isStarting) {
      return;
    }

    setIsStarting(true);

    video.pause();
    video.currentTime = 0;
    video.defaultMuted = false;
    video.muted = false;
    video.volume = 1;

    try {
      await video.play();
      setHasStarted(true);
    } catch (playError) {
      try {
        video.pause();
        video.currentTime = 0;
        video.defaultMuted = true;
        video.muted = true;
        await video.play();
        setHasStarted(true);
      } catch (mutedPlayError) {
        setHasStarted(false);
      }
    } finally {
      setIsStarting(false);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleStart();
    }
  };

  return (
    <div className="intro-container">
      <video
        ref={videoRef}
        className="intro-video"
        {...(videoSrc ? { src: videoSrc } : {})}
        onEnded={onComplete}
        playsInline
        preload="auto"
      />

      {!hasStarted && (
        <div
          className={`intro-overlay${isStarting ? ' starting' : ''}`}
          role="button"
          tabIndex={0}
          aria-label="Tap anywhere to start intro"
          aria-disabled={!videoSrc || isStarting}
          onClick={handleStart}
          onKeyDown={handleKeyDown}
        >
          <div className="intro-branding">
            <img src="/eddie-logo.svg" alt="Eddie TV" className="intro-logo" />
            <p className="intro-kicker">EDDIE TV</p>
            <p className="intro-copy">Tap anywhere to start</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Intro;
